module.exports = __webpack_public_path__ + "54cf98f5/img/lock-icon.bb9c7166.svg";